<template>
    <div class="codics-admin-lottery-body">
        <div class="codics-admin-lottery-control" style="margin-bottom: 20px;">
            <el-button class="codics-admin-lottery-control-search" type="success" icon="el-icon-plus"
                @click="addLotteryDialog = true;" plain>添加员工</el-button>
            <!-- 添加表单 -->
            <el-dialog title="添加活动" :visible.sync="addLotteryDialog" width="80%">
                <el-form :model="addForm">
                    <el-form-item label="活动名称" :label-width="formLabelWidth">
                        <el-input v-model="addForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="初始抽奖次数" :label-width="formLabelWidth">
                        <el-input-number v-model="addForm.count" :min="0" :max="100000"
                            label="初始抽奖次数"></el-input-number>
                    </el-form-item>
                    <el-form-item label="活动状态" :label-width="formLabelWidth">
                        <el-select v-model="addForm.state" placeholder="请选择活动状态">
                            <el-option label="上架" value='0'></el-option>
                            <el-option label="下架" value='1'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动类型" :label-width="formLabelWidth">
                        <el-select v-model="addForm.type" placeholder="请选择活动类型">
                            <el-option label="线上" value='0'></el-option>
                            <el-option label="线下" value='1'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否开启填写信息领奖(仅线下模式生效)" :label-width="formLabelWidth">
                        <el-select v-model="addForm.ist" placeholder="请选择核销类型">
                            <el-option label="关闭" value='0'></el-option>
                            <el-option label="开启" value='1'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动规则" :label-width="formLabelWidth">
                        <el-input v-model="addForm.remark" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="JS代码" :label-width="formLabelWidth">
                        <el-input v-model="addForm.js" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="CSS代码" :label-width="formLabelWidth">
                        <el-input v-model="addForm.css" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间" :label-width="formLabelWidth">
                        <el-date-picker v-model="timeIndex" type="datetimerange" @change="timePick"
                            value-format="timestamp" :picker-options="pickerOptions" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" align="right">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addLotteryDialog = false;">取 消</el-button>
                    <el-button type="primary" @click="addActiveFuc">确 定</el-button>
                </div>
            </el-dialog>
            <el-input class="codics-admin-lottery-control-search" style="width: 300px !important;"
                placeholder="请输入活动名称..." v-model="searchTxt" clearable @input="searchChange">
                <el-button style="padding: 0 0px 0 15px;margin-right: 0 !important;" slot="append" icon="el-icon-search"
                    @click="searchPage = 1; searchMax = 0; searchData = []; nowSearchTxt = searchTxt; getActiveData();"></el-button>
            </el-input>
            <el-popconfirm :title="'您确定要删除当前选中的' + selectData.length + '条数据吗？'" @confirm="deleteActiveFuc">
                <el-button class="codics-admin-lottery-control-search iconfont" slot="reference" type="danger"
                    icon="el-icon-delete" plain>批量删除</el-button>
            </el-popconfirm>
        </div>
        <el-table stripe class="codics-admin-lottery-table" :data="searchTxt == '' ? lotteryData : searchData" border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column prop="id" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="180">
            </el-table-column>
            <el-table-column prop="count" label="次数" width="80">
            </el-table-column>
            <el-table-column align="right" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="listLotterysFuc(scope);" style="margin-right: 10px;">编辑</el-button>
                    <el-popconfirm title="您确定要删除当前数据吗？" @confirm="deleteActiveFuc([scope.row.id])">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="codics-admin-lottery-table-page" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
            layout="total, sizes, prev, pager, next, jumper" :total="searchTxt == '' ? maxSize : searchMax">
        </el-pagination>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import * as qiniu from 'qiniu-js';
import { listPrizes3, addLottery, queryProduct, listActives, addActive, deleteActive, updateActive } from '@/api';
export default {
    data() {
        return {
            searchTxt: '',
            addLotteryDialog: false,
            updateLotteryDialog: false,
            addForm: {
                name: '',
                count: 1,
                state: '0',
                type: '0',
                ist: '0',
                remark: '',
                js: '',
                css: '',
                stime: new Date().getTime(),
                etime: new Date().getTime() + 3600 * 1000 * 24 * 7
            },
            updateForm: {
                name: '',
                count: 1,
                state: '0',
                type: '0',
                ist: '0',
                def: 0,
                remark: '',
                js: '',
                css: '',
                stime: new Date().getTime(),
                etime: new Date().getTime() + 3600 * 1000 * 24 * 7
            },
            qiNiuInfo: {
                token: ''
            },
            prizeData: [],
            timeIndex: [],
            timeIndex2: [],
            formLabelWidth: '120px',
            searchBrand: '名称',
            currentPage: 1,
            searchPage: 1,
            tableData: [],
            searchData: [],
            selectData: [],
            multipleSelection: [],
            maxSize: 0,
            searchMax: 0,
            dataSize: 10,
            searchSize: 10,
            lotteryData: [],
            shopLoad: false,
            productOptions: [],
            nowSearchTxt: '',
            addSelect: '',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        }
    },
    mounted() {

        this.$emit('check-mem');

        this.getActiveData();

    },
    methods: {
        async listLotterysFuc(scope) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listPrizes3({ id: scope.row.id });

            loading.close();

            if (data.code == 200) {

                this.prizeData = [{ name: '不绑定', id: 0 }, ...data.data];

                this.updateForm = scope.row;

                this.updateLotteryDialog = true;

                this.updateForm.stime = new Date(scope.row.stime).getTime();

                this.updateForm.etime = new Date(scope.row.etime).getTime();

                this.timeIndex2 = [new Date(scope.row.stime).getTime(), new Date(scope.row.etime).getTime()];

            } else {

                this.$message.error(data.message);

            }

        },
        defChange(a) {
            this.updateForm.def = a ? a : 0;
        },
        async creatQrCode(i, QRlink) {   // QRlink是二维码的内容
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: QRlink,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            await QRCode.toDataURL(QRlink, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                i['qrcode'] = url;
            });
        },
        async updateActiveFuc() {

            if (this.updateForm.name == '') {

                this.$message.error('活动名称不能为空！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await updateActive(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '更新活动成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async deleteActiveFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteActive({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.data + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        async addActiveFuc() {

            if (this.addForm.name == '') {

                this.$message.error('活动名称不能为空！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await addActive(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '添加活动成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        timePick(a) {

            this.addForm.stime = a ? a[0] : new Date().getTime();

            this.addForm.etime = a ? a[1] : new Date().getTime() + 3600 * 1000 * 24 * 7;

        },
        timePick2(a) {

            this.updateForm.stime = a ? a[0] : new Date().getTime();

            this.updateForm.etime = a ? a[1] : new Date().getTime() + 3600 * 1000 * 24 * 7;

        },
        async getActiveData() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listActives({ key: this.nowSearchTxt, pge: this.searchTxt == '' ? this.currentPage : this.searchPage, psz: this.searchTxt == '' ? this.dataSize : this.searchSize });

            loading.close();

            if (data.code == 200) {

                if (this.nowSearchTxt == '') {

                    this.lotteryData = data.data;

                    this.maxSize = data.data1;

                    this.initQrcode(this.lotteryData);

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.data1;

                    this.initQrcode(this.searchData);

                }

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.getActiveData();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.getActiveData();
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        typeFilter(v, r, c) {

            return r.type === v;

        },
        istFilter(v, r, c) {

            return r.ist === v;

        },
        handleSubCat(value) {
            // 获取value值
            this.addForm.p = value.length == 0 ? 0 : value[value.length - 1];
            // 获取label 值
            // console.log(this.$refs["refSubCat"].getCheckedNodes()[0].label)
        },
        async queryProductData(query) {

            if (query !== '') {
                this.shopLoad = true;
                let data = await queryProduct({ key: query });
                this.shopLoad = false;
                if (data.code == 200) {

                    this.$message({
                        message: '查询商品成功！',
                        type: 'success'
                    });

                    this.productOptions = data.data;

                } else {

                    this.$message.error(data.message);

                    this.productOptions = [];

                }

            } else {

                this.productOptions = [];

            }

        },
        selectChange(key) {
            this.addForm.pid = key.id;
            this.addForm.name = key.name;
        },
        // 图片点击预览
        handlePictureCardPreview(file) {

        },
        // 上传方法
        uploadFile(uploadInfo) {

            this.addForm.img = 'huayuan/img/' + uploadInfo.file.name.replace(',', '');

            const _that = this;
            // 上传文件
            const observer = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    _that.addForm.img = res.key;
                }
            }
            const observable = qiniu.upload(uploadInfo.file, 'huayuan/img/' + uploadInfo.file.name, this.qiNiuInfo.token, {}, {

            })
            const subscription = observable.subscribe(observer) // 上传开始
            // console.log(subscription);
            // subscription.unsubscribe() // 上传取消
        },
        // 图片删除
        handleRemove(file, fileList) {
            // console.log("123123123:",file, fileList);

            this.fmList = this.fmList.filter(item => item.indexOf(file.name.replace(',', '')) == -1);
        },
        clearSelect() {
            this.addForm.pid = '';
            this.addForm.count = 0;
        },
        async addLotteryFuc() {
            if (this.addForm.pid == '' || this.addForm.name == '' || this.addForm.img == '') {

                this.$message({
                    showClose: true,
                    message: '请先选中合适的奖品并上传名称及图片！',
                    type: 'warning'
                });

                return true;

            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await addLottery(this.addForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '数据添加成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        initQrcode(t) {
            for (var i in t) {
                this.creatQrCode(t[i], "https://factory.katihuo.com/wx/" + t[i].id);
            }
        }
    }
}
</script>

<style>
/* 后台管理端主页 */
.codics-admin-lottery-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
    padding: 20px;
}

/* 后台管理页面主页 */
.codics-admin-lottery-control {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

/* 后台管理页面主页控制栏 */
.codics-admin-lottery-control-input {
    width: 200px !important;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
}

/* 后台管理页面控制栏搜索按钮 */
.codics-admin-lottery-control-search {
    position: relative;
    float: left;
    margin-left: 0px !important;
    margin-right: 20px !important;
}

/* 表格控件 */
.codics-admin-lottery-table {
    height: fit-content;
    width: 100% !important;
    position: relative;
    float: left;
    margin-bottom: 20px;
}

/* 表格分页控件 */
.codics-admin-lottery-table-page {
    position: relative;
    float: right;
    right: 0;
}
</style>